export class Reference {
	packageSize: number | null;

	referenceBasketVersion: string;

	historicProductDataViewDate: Date | null;

	referencedProductType: string | null;

	decisionNumber: string | null;

	fxUpdatePrice: number | null;

	fxUpdatePriceEnabled: boolean;

	prgPrbPrice: number | null;

	prgPrbPriceEnabled: boolean;

	priPrice: number | null;

	priPriceEnabled: boolean;

	lossOfExclusivity: string | null;

	gtin: string | null;

	constructor(
		packageSize: number | null,
		referenceBasketVersion: string,
		historicProductDataViewDate: Date | null,
		referencedProductType: string | null,
		decisionNumber: string | null,
		fxUpdatePrice: number | null,
		fxUpdatePriceEnabled: boolean,
		prgPrbPrice: number | null,
		prgPrbPriceEnabled: boolean,
		priPrice: number | null,
		priPriceEnabled: boolean,
		lossOfExclusivity: string | null,
		gtin: string | null
	) {
		this.packageSize = packageSize;
		this.referenceBasketVersion = referenceBasketVersion;
		this.historicProductDataViewDate = historicProductDataViewDate;
		this.referencedProductType = referencedProductType;
		this.decisionNumber = decisionNumber;
		this.fxUpdatePrice = fxUpdatePrice;
		this.fxUpdatePriceEnabled = fxUpdatePriceEnabled;
		this.prgPrbPrice = prgPrbPrice;
		this.prgPrbPriceEnabled = prgPrbPriceEnabled;
		this.priPrice = priPrice;
		this.priPriceEnabled = priPriceEnabled;
		this.lossOfExclusivity = lossOfExclusivity;
		this.gtin = gtin;
	}
}
